import api from '../api';
let apiUrl = 'abonnements';

const state = {
    data: {},
    meta: {}
};

const actions = {
    show: async ({ commit }, id) => {
        return await api
            .get(`/api/v1/${apiUrl}/${id}`)
            .then((response) => {
                commit('set', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    store: async ({ commit }, data) => {
        return await api
            .post(`/api/v1/${apiUrl}/${data.id}`, data)
            .then((response) => {
                commit('set', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    update: async ({ commit }, data) => {
        return await api
            .put(`/api/v1/${apiUrl}/${data.id}`, data)
            .then((response) => {
                commit('set', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    cancel: async ({ commit }, data) => {
        return await api
            .put(`/api/v1/${apiUrl}/${data.id}/cancel`, data)
            .then((response) => {
                commit('set', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, data) {
        state.data = data.data;
        state.meta = data.meta;
    }
};

const getters = {
    get: (state) => {
        return state.data;
    },
    getMeta: (state) => {
        return state.meta;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
